import { getProductAvailabilityResponse } from "@dana/Services/DanaProductAvailabilityService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { WarehouseDto } from "@insite/client-framework/Types/ApiModels";

export const OrderTypes = {
    STOCK: "ZOR",
    EMERGENCY: "ZSO",
    ANNUALRETURNS: "ZARN",
    STANDARDRETURNS: "ZRET",
} as const;
export type OrderType = (typeof OrderTypes)[keyof typeof OrderTypes];

export interface AvailabilityDirectShipResponse {
    correlationId: string;
    leadTimeInDays: number;
    partId: string;
    plantCode: string;
    quantityBTOAvail: number;
    quantityFGAvail: number;
    quantityRequested: number;
    timeStampInUTC: string;
    totalTimeInMilliSec: number;
}

export interface DanaWarehouseDto extends WarehouseDto {
    properties: { [key: string]: string };
}
export interface InventryLocation {
    id:string;
    location: DanaWarehouseDto;
    committedQuantity: number;
    availabilityQuantity?: number;
    selectedQuantity?: number;
    committedDate?: string; // ISO date string format
}

export interface PriceAvailabilityResponse {
    customerPartPrice: CustomerPartPrice;
    inventory: PartInventory;
    locations: InventryLocation[] | null
    error: boolean;
    errorMessage: string;
}

export interface CustomerPartPrice {
    coreCharge: number;
    coreChargeDisplay: string;
    currency: string;
    discount: number;
    partNumber: string | undefined;
    price: number;
    unitListPrice: number;
    unitListPriceDisplay: string;
    extendedUnitListPrice: number;
    extendedUnitListPriceDisplay: string;
    tarrif: number;
    message: PriceAvailabilityMessage;
}

export interface PartInventory {
    abcCode: string;
    availableQuantity: number;
    cumlativeLeadTime: number;
    description: string;
    leadTime: number;
    partNumber: string;
    plantCode: string;
    safetyStock: number;
    plantVendorNumber: string;
    storageLocation: string;
    loadingGroup: string;
    message: PriceAvailabilityMessage;
    receiptInfo: InventoryReceiptInfo[];
}

export interface InventoryReceiptInfo {
    committedQuantity: number;
    committedDate: string | null; // ISO string expected from backend (e.g. "2025-06-23T10:30:00Z")
    plannedDeliveryTime: string | null;
    fgAvailability: string;
}

export interface PriceAvailabilityMessage {
    messageID: string;
    messageType: string;
    message: string;
}

export interface GetProductAvailabilityParameter {
    plantCode?: string;
    productNumber: string;
    quantity?: number;
    orderType?: string;
    customerNumber?: string;
}

export interface GetAvailabilityExtendedParameter {
    plantCode?: string;
    partId: string;
    quantityRequested?: number;
    orderType?: string;
}

export interface GetLcInventoryParameter {
    billTo?: string;
    partNumber: string;
    plantCode?: string;
}

export interface LcInventoryResponse {
    partNumber: string;
    partDescription: string;
    availableQuantity: number;
    plant: string;
    city: string;
    state: string;
}


interface Props {
    apiParameter: GetProductAvailabilityParameter;
    apiResult: PriceAvailabilityResponse;
}
type HandlerType = Handler<GetProductAvailabilityParameter, Props>;


export const SetParameters: HandlerType = props => {
    props.apiParameter = {
        productNumber: props.parameter.productNumber,
        quantity: props.parameter.quantity,
        orderType: props.parameter.orderType,
        customerNumber: props.parameter.customerNumber,
        plantCode: props.parameter.plantCode
    };
    const state = props.getState() as ApplicationStateDana;
    props.dispatch?.({
        type: "ProductAvailability/Start",
        isLoading: true,
        avilabilityLoadSuccess: state.productAvailabilityState?.productNumber === props.parameter.productNumber,
    } as any);
}

export const GetAvailability: HandlerType = async props => {

    let result = await getProductAvailabilityResponse(props.apiParameter);
    if (result == null) {
        return;
    }

    props.apiResult = result;

    props.dispatch?.({
        type: "ProductAvailability/LoadResponse",
        productNumber: props.parameter.productNumber,
        customerPartPrice: result.customerPartPrice,
        productAvailability: result.inventory,
        locations: result.locations,
        orderType: props.apiParameter.orderType
    } as any);

}
export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "ProductAvailability/End",
        isLoading: false,
        avilabilityLoadSuccess: !props.apiResult.error,
        errorMessage: props.apiResult.errorMessage

    } as any);
}
export const chain = [
    SetParameters,
    GetAvailability,
    SetLoadingOff
];

const getProductAvailability = createHandlerChainRunner(chain, "GetProductAvailabilityHandler");
export default getProductAvailability;
